<script setup>
definePageMeta({
  layout: 'sdslayout'
})

const pdfSrc = ref("/pdf/Sharpie_3000.pdf")

</script>

<template>
  <!-- PDF works with client side only -->
   <div>
    <AppPdfViewer :src="pdfSrc" />
  </div>
</template>